/**
 * @generated SignedSource<<3f0f07e212abd1ca223dd6761d69c860>>
 * @relayHash 8351feb0d3f07fa57a931145f947d2c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b72951c1711fef2666f26843016ea0cb72216fd82b28a10f7b0dd85621145d96

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderGroupsPageQuery$variables = {
  after?: string | null | undefined;
  first: number;
};
export type StakeholderGroupsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StakeholderGroupPageContent">;
};
export type StakeholderGroupsPageQuery = {
  response: StakeholderGroupsPageQuery$data;
  variables: StakeholderGroupsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "StakeholderGroupPageContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholderGroupsAndStakeholders",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "StakeholderCommsStakeholderGroup",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "services"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ]
                  },
                  {
                    "concreteType": "StakeholderCommsStakeholder",
                    "kind": "LinkedField",
                    "name": "stakeholders",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "avatar"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "concreteType": "StakeholderCommsNotificationPreference",
                        "kind": "LinkedField",
                        "name": "notificationPreference",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "emailId"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerAvatar"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "handle": "connection",
        "key": "StakeholderGroupTableLayout_stakeholderComms_getStakeholderGroupsWithStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders"
      }
    ]
  },
  "params": {
    "id": "b72951c1711fef2666f26843016ea0cb72216fd82b28a10f7b0dd85621145d96",
    "metadata": {},
    "name": "StakeholderGroupsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ce93b94ed54a7afc00ff594c131c3334";

export default node;
